export const MOCK_COMPROBANTE = {
  id: '2025-00042',
  date: '2026-04-10',
  client_name: 'Edificio Villamagna',
  client_rut: '77.123.456-7',
  recepcionist_name: 'Carla Escalona',
  specialist_name: 'Juan Pérez',
  reason: 'Atención preventiva mensual',
  attention_init: '09:00',
  attention_finish: '11:30',
  equipment: 'Ascensor #1, Ascensor #2',
  finish_state: 'OK',
  observations:
    'Se realizaron las rutinas preventivas según protocolo. Todos los equipos operativos.',
  images: [],
};

export const MOCK_ORDEN = {
  id_budget: '2025-P-00131',
  order_init: '2026-04-12',
  client_name: 'Edificio Villamagna',
  client_rut: '77.123.456-7',
  specialist_name: 'Juan Pérez',
  recepcionist_name: 'Carla Escalona',
  items: [
    { description: 'Cambio de botonera cabina', quantity: 1, unit: 'und' },
    { description: 'Engrase de guías', quantity: 2, unit: 'hrs' },
    { description: 'Ajuste de puertas piso 3', quantity: 1, unit: 'und' },
  ],
};

// Mock preview del editor para el informe anual de mantenciones por cliente.
// Shape aplanado por el modal (InformeAnualMantencionesModal) antes de pasar
// al TemplateRenderer — el backend devuelve cliente/periodo anidados; el
// modal los flattea y agrega `closed_at_fmt` ya formateado.
export const MOCK_INFORME_ANUAL_MANTENCIONES = {
  cliente_nombre: 'Edificio Villamagna',
  cliente_rut: '77.123.456-7',
  periodo_desde: '2025-04-20',
  periodo_hasta: '2026-04-20',
  total_mantenciones: 4,
  mantenciones: [
    {
      id: 101,
      closed_at_fmt: '2025-05-12',
      tecnico_nombre: 'Juan Pérez',
      tecnico_rut: '11.111.111-1',
      observaciones: 'Mantención de rutina sin novedad.',
    },
    {
      id: 128,
      closed_at_fmt: '2025-08-23',
      tecnico_nombre: 'Carla Escalona',
      tecnico_rut: '22.222.222-2',
      observaciones: 'Ajuste de puertas y cambio de estop.',
    },
    {
      id: 154,
      closed_at_fmt: '2025-11-04',
      tecnico_nombre: 'Juan Pérez',
      tecnico_rut: '11.111.111-1',
      observaciones: '',
    },
    {
      id: 189,
      closed_at_fmt: '2026-02-18',
      tecnico_nombre: 'Carla Escalona',
      tecnico_rut: '22.222.222-2',
      observaciones: 'Engrase de guías y revisión de iluminación.',
    },
  ],
};

export const MOCK_RANKING_MENSUAL = {
  cliente_nombre: 'Edificio Villamagna',
  mes_legible: 'Marzo 2026',
  total_mantenciones: 4,
  total_respuestas: 120,
  total_rechazos: 18,
  pct_rechazo_global: 15,
  top_items: [
    { titulo: 'Comprobación stop', categoria: 'Cabina', rechazos: 8, pct_rechazo: 66.7 },
    {
      titulo: 'Iluminación escotilla',
      categoria: 'Sala de máquinas',
      rechazos: 5,
      pct_rechazo: 41.7,
    },
    { titulo: 'Ajuste de puertas', categoria: 'Puerta', rechazos: 3, pct_rechazo: 25 },
  ],
  reincidencia: [
    { ascensor: 'Ascensor #1', titulo: 'Comprobación stop', rechazos: 3 },
    { ascensor: 'Ascensor #2', titulo: 'Iluminación escotilla', rechazos: 2 },
  ],
  por_categoria: [
    { categoria: 'Cabina', respuestas: 40, rechazados: 8, pct_rechazo: 20 },
    { categoria: 'Sala de máquinas', respuestas: 32, rechazados: 5, pct_rechazo: 15.6 },
    { categoria: 'Puerta', respuestas: 28, rechazados: 3, pct_rechazo: 10.7 },
    { categoria: 'Foso', respuestas: 20, rechazados: 2, pct_rechazo: 10 },
  ],
  serie_6m: [
    { mes: '2025-10', respuestas: 100, rechazados: 12, pct_rechazo: 12 },
    { mes: '2025-11', respuestas: 105, rechazados: 10, pct_rechazo: 9.5 },
    { mes: '2025-12', respuestas: 98, rechazados: 14, pct_rechazo: 14.3 },
    { mes: '2026-01', respuestas: 110, rechazados: 13, pct_rechazo: 11.8 },
    { mes: '2026-02', respuestas: 115, rechazados: 16, pct_rechazo: 13.9 },
    { mes: '2026-03', respuestas: 120, rechazados: 18, pct_rechazo: 15 },
  ],
  mantenciones: [
    {
      fecha: '2026-03-05',
      tecnico: 'Juan Pérez',
      ascensores: 'Ascensor #1, Ascensor #2',
      respuestas: 32,
      rechazos: 5,
    },
    {
      fecha: '2026-03-12',
      tecnico: 'Carla Escalona',
      ascensores: 'Ascensor #1',
      respuestas: 28,
      rechazos: 3,
    },
    {
      fecha: '2026-03-20',
      tecnico: 'Juan Pérez',
      ascensores: 'Ascensor #2',
      respuestas: 30,
      rechazos: 4,
    },
    {
      fecha: '2026-03-27',
      tecnico: 'Juan Pérez',
      ascensores: 'Ascensor #1, Ascensor #2',
      respuestas: 30,
      rechazos: 6,
    },
  ],
};

// Mock preview del editor. Incluye los runtime vars del budget/cliente +
// valores de ejemplo para las 22 keys de tenant_text documentType='presupuesto'
// (los que el endpoint unificado /presupuestos/document-static-data entrega
// aplanados a runtime).
export const MOCK_PRESUPUESTO = {
  // Runtime — del budget
  id: '2025-P-00131',
  date: '2026-04-18',
  reason: 'Modernización motor de tracción',
  description:
    'Reemplazo del motor de tracción por falla del sistema de frenado. Incluye instalación y pruebas de carga.',
  conditions: '50% al aprobar, 50% al finalizar. Pago en CLP a la vista.',
  finishTime: '2 semanas desde la aprobación.',
  include: 'mano de obra, materiales y traslado',
  guarantee: '12 meses',
  // M1 (review 2026-07-13): el snapshot de la cláusula del catálogo (Task 6/7)
  // y el booleano que decide qué sección de garantía imprime el motor
  // (visibleIf en pdfTemplate.srv.ts). Sin esto, el editor low-code nunca
  // muestra la sección nueva ni lista `{guarantee_text}` como variable.
  guarantee_text:
    'PROLIFT Ingeniería y Ascensores Ltda. garantiza el repuesto suministrado y la mano de obra asociada a su instalación por un período de 12 meses, contado desde la fecha de puesta en servicio del equipo.',
  has_guarantee_clause: true,
  discount: 0.1,
  moneda: 'CLP',
  tipo_cambio_snapshot: null,
  items: [
    {
      elevator: 'Ascensor #1',
      description: 'Motor de tracción 7.5kW',
      quantity: 1,
      unitValue: 2500000,
    },
    {
      elevator: 'Ascensor #1',
      description: 'Mano de obra (instalación)',
      quantity: 8,
      unitValue: 45000,
    },
    { elevator: 'Ascensor #2', description: 'Ajuste polea guía', quantity: 1, unitValue: 180000 },
  ],
  images: [],
  // Runtime — del cliente (aplanado con prefijo client_*)
  client_name: 'Edificio Villamagna',
  client_rut: '77.123.456-7',
  client_address: 'Av. Providencia 1234',
  client_commune: 'Providencia',
  client_phone: '+56 2 2345 6789',
  client_email: 'admin@villamagna.cl',
  client_contact: 'María Fernández',
  // Tenant_texts (seeds Prolift en SQL 52.0.sql)
  secondary_title: 'Lift Logic',
  portrait_tagline: 'Soluciones en Elevación y Mantenimiento',
  right_header_1: '',
  right_header_2: '',
  right_header_3: '',
  footer: 'LiftLogic - Por Sociedad Stiltech SpA',
  footer_secondary: 'www.liftlogic.cl',
  bank: 'Banco de Chile',
  account_type: 'Cuenta Corriente',
  account_number: '123-456-789',
  account_holder: 'Stiltech SpA',
  bank_rut: '77.111.222-3',
  bank_email: 'pagos@liftlogic.cl',
  bank_extra: '',
  titular: 'David Silva',
  titular_titulo: 'Licenciado en ciencias de la ingeniería',
  titular_cargo: 'Cofundador de STIL',
  closing_paragraph:
    'Esperando una buena acogida del presente informe y a la espera de sus noticias, no nos queda más que agradecer su interés y esperamos contar con su confianza.',
  guarantee_disclaimer:
    '. Por efectos de fallas de fabricación, diseño o instalación no incluyendo en esta garantía los daños causados por intervenciones de terceros, actos de vandalismo, problemas de voltaje, desastres naturales, incendios, o daños no atribuibles a su uso normal.',
  conditions_note: 'Nota: Los valores de cada ítem incluyen ',
  conditions_validity: 'El presupuesto tiene validez de 10 días corridos.',
  conditions_warning:
    'LUEGO DE ESTE PLAZO, PROLIFT SE RESERVA EL DERECHO A MODIFICAR VALORES Y TIEMPOS DE EJECUCIÓN.',
};

export const MOCK_INFORME_MANTENCION = {
  comunidad: 'Comunidad Edificio Demo',
  direccion: 'Av. Siempre Viva 742, Providencia',
  mail: 'contacto@demo.cl',
  especialista: 'Carlos Hernández',
  tipo_servicio: 'Mantención preventiva',
  fecha: '15 de junio de 2026',
  equipos_label: '4 ascensores · A1 / A2 / A3 / A4',
  numero: 1084,
  n_equipos: 4,
  n_actividades: 5,
  n_conformes: 16,
  n_incidencias: 4,
  observaciones: 'Sin observaciones generales.',
  // Dataset rico para iterar el layout "bloque por ascensor": 4 ascensores,
  // 3 sectores, varios hallazgos por item, severidad mixta y un caso legacy
  // (Pulsadores/A1 sin hallazgos[] → fallback obs/sug).
  inspeccion: [
    {
      sector: 'Seguridad',
      items: [
        {
          act: 'Cables de tracción',
          cells: {
            A1: { estado: 'FUNCIONANDO', obs: 'Estado normal', sug: '' },
            A2: {
              estado: 'FALLA',
              obs: 'Hebras cortadas en tramo superior; lubricación deficiente',
              hallazgos: [
                {
                  descripcion: 'Hebras cortadas en tramo superior',
                  severidad: 'ALTA',
                  sugerencia: 'Programar reemplazo de cable',
                },
                { descripcion: 'Lubricación deficiente', severidad: 'MEDIA', sugerencia: null },
              ],
            },
            A3: { estado: 'FUNCIONANDO', obs: 'Estado normal', sug: '' },
            A4: { estado: 'FUNCIONANDO', obs: 'Estado normal', sug: '' },
          },
        },
        {
          act: 'Paracaídas / freno de emergencia',
          cells: {
            A1: { estado: 'FUNCIONANDO', obs: 'Estado normal', sug: '' },
            A2: { estado: 'FUNCIONANDO', obs: 'Estado normal', sug: '' },
            A3: {
              estado: 'FALLA',
              obs: 'Cuña no acciona en prueba de sobrevelocidad',
              hallazgos: [
                {
                  descripcion: 'Cuña no acciona en prueba de sobrevelocidad',
                  severidad: 'CRITICA',
                  sugerencia: 'Detener equipo hasta corrección',
                },
              ],
            },
            A4: { estado: 'FUNCIONANDO', obs: 'Estado normal', sug: '' },
          },
        },
      ],
    },
    {
      sector: 'Cabina',
      items: [
        {
          act: 'Pulsadores',
          cells: {
            A1: {
              estado: 'FALLA',
              obs: 'Botón de planta baja sin respuesta',
              sug: 'Reemplazar pulsador',
            },
            A2: { estado: 'FUNCIONANDO', obs: 'Estado normal', sug: '' },
            A3: { estado: 'FUNCIONANDO', obs: 'Estado normal', sug: '' },
            A4: { estado: 'FUNCIONANDO', obs: 'Estado normal', sug: '' },
          },
        },
        {
          act: 'Iluminación',
          cells: {
            A1: { estado: 'FUNCIONANDO', obs: 'Estado normal', sug: '' },
            A2: { estado: 'FUNCIONANDO', obs: 'Estado normal', sug: '' },
            A3: { estado: 'FUNCIONANDO', obs: 'Estado normal', sug: '' },
            A4: { estado: 'FUNCIONANDO', obs: 'Estado normal', sug: '' },
          },
        },
      ],
    },
    {
      sector: 'Sala de máquinas',
      items: [
        {
          act: 'Nivel de aceite',
          cells: {
            A1: { estado: 'FUNCIONANDO', obs: 'Estado normal', sug: '' },
            A2: {
              estado: 'FALLA',
              obs: 'Nivel por debajo del mínimo',
              hallazgos: [
                {
                  descripcion: 'Nivel por debajo del mínimo',
                  severidad: 'MEDIA',
                  sugerencia: 'Rellenar en próxima visita',
                },
              ],
            },
            A3: { estado: 'FUNCIONANDO', obs: 'Estado normal', sug: '' },
            A4: { estado: 'FUNCIONANDO', obs: 'Estado normal', sug: '' },
          },
        },
      ],
    },
  ],
  // overrides de tenant_text (textKey) — vacíos usan el body del template
  carta_intro: '',
  observaciones_generales: '',
  info_entrega: '',
  // firmas (SignaturesSection las lee de data)
  specialist_name: 'Carlos Hernández',
  specialist_signature: null,
  recepcionist_name: 'Juan Pérez',
  recepcionist_signature: null,
};

export const VARIABLES_BY_TYPE = {
  comprobante: [
    'id',
    'date',
    'client_name',
    'client_rut',
    'recepcionist_name',
    'specialist_name',
    'reason',
    'attention_init',
    'attention_finish',
    'equipment',
    'finish_state',
    'observations',
  ],
  orden: [
    'id_budget',
    'order_init',
    'client_name',
    'client_rut',
    'specialist_name',
    'recepcionist_name',
  ],
  ranking_mensual: [
    'cliente_nombre',
    'mes_legible',
    'total_mantenciones',
    'total_respuestas',
    'total_rechazos',
    'pct_rechazo_global',
  ],
  informe_anual_mantenciones: [
    'cliente_nombre',
    'cliente_rut',
    'periodo_desde',
    'periodo_hasta',
    'total_mantenciones',
  ],
  presupuesto: [
    'id',
    'date',
    'reason',
    'description',
    'conditions',
    'finishTime',
    'include',
    'guarantee',
    'guarantee_text',
    'has_guarantee_clause',
    'discount',
    'moneda',
    'tipo_cambio_snapshot',
    'client_name',
    'client_rut',
    'client_address',
    'client_commune',
    'client_phone',
    'client_email',
    'client_contact',
  ],
  informe_mantencion: [
    'comunidad',
    'direccion',
    'mail',
    'especialista',
    'tipo_servicio',
    'fecha',
    'equipos_label',
    'n_equipos',
    'n_actividades',
    'n_conformes',
    'n_incidencias',
    'observaciones',
  ],
};

export const getMockData = (documentType) => {
  if (documentType === 'orden') return MOCK_ORDEN;
  if (documentType === 'ranking_mensual') return MOCK_RANKING_MENSUAL;
  if (documentType === 'presupuesto') return MOCK_PRESUPUESTO;
  if (documentType === 'informe_anual_mantenciones') return MOCK_INFORME_ANUAL_MANTENCIONES;
  if (documentType === 'informe_mantencion') return MOCK_INFORME_MANTENCION;
  return MOCK_COMPROBANTE;
};
